import { combineReducers } from 'redux'
import * as redukers from 'reduker'
import * as actionTypes from './action-types'

export default combineReducers({
  main: redukers.value({
    set: actionTypes.SHOW,
    reset: actionTypes.HIDE,
  }),
  confirmation: redukers.value({
    set: actionTypes.SHOW_CONFIRMATION,
    reset: actionTypes.HIDE_CONFIRMATION,
  }),
  notifications: redukers.value(
    {
      set: actionTypes.SET_SNACKBARS,
      reset: actionTypes.RESET_SNACKBARS,
    },
    [],
  ),
})
